import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/case-studies/animal-debt/Lets-talk-copy.webp";
import { Link } from "gatsby";

function Animaltalkcta() {
  return (
    <section className="animal-talk-cta p-100 text_white">
      <Container>
        <div
          className="cta-main"
          style={{
            backgroundImage: `url(${BgImg})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <Row className="h-100 align-items-center">
            <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="">
              <h2>Want to achieve similar success? Let's talk.</h2>
              <Link
                style={{
                  background: "transparent",
                  color: "#fff",
                  border: "1px solid #fff",
                }}
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Get in Touch
              </Link>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
}

export default Animaltalkcta;
